module.exports = __webpack_public_path__ + "static/images/styles/images/nations/uk-cn.9729d2d7.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/uk-cn.png
// module id = 3673
// module chunks = 11